<template>
  <div v-if="dataLoaded" class="spo-card spo-card-shadowed rounded pa-0 overflow-hidden bg-white">
    <div ref="enteteCoureurRef">
      <EnteteCoureur :inscription="inscription" :index="0" :isFinished="false" noDelete />
    </div>



    <StepperTransfert :current_step="current_step" @goToStep="goToStep($event)" class="bg-spo-light" />

    <ExpandTransition :show="current_step == '1'">
      <IdentiteCoureur v-if="ids_selected_parcours.length > 0" :item="inscription" :ids_parcours="ids_selected_parcours"
        :canGoBack="false" @onIncoherence="display_incoherence" @goToNextStep="goToConfirmationStep()" />
    </ExpandTransition>

    <ExpandTransition :show="current_step == '2'">
      <div>
        <div class="my-4 mx-2">
          <div v-if="mainStore.authUser.isLogged">
            <p>Connecté en tant que {{ mainStore.authUser.userMail }}</p>
            <p class="text-body-2 mt-2">Vous pouvez confirmer le transfert de cette inscription vers votre compte.</p>
          </div>
          <div v-else>
            <v-alert class="mb-2" density="compact">
              Vous devez vous connecter à votre {{ account_wording[1] }} Sportips via le formulaire ci-dessous afin de
              confirmer le transfert de l'inscription.
            </v-alert>
            <LoginForm />
          </div>
        </div>
        <NavigationStepButtons :canContinue="mainStore.authUser.isLogged" :canGoBack="true" :loading="onload"
          continueLabel="Confirmer le transfert" @goToNextStep="post()" @goToPreviousStep="goToIdentityStep()"
          class="bg-spo-light" />
      </div>
    </ExpandTransition>

    <IncoherencePopupDialog :incoherence="incoherence_response" />
  </div>
  <v-skeleton-loader v-else class="mx-auto" type="image" min-height="400" />
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import IdentiteCoureur from "@/components/Inscription/IdentiteCoureur.vue";
import LoginForm from "@/components/Authentification/LoginForm.vue";
import ExpandTransition from "@/components/App/UI/ExpandTransition.vue";
import EnteteCoureur from "@/components/Inscription/InscriptionItem/EnteteCoureur.vue";
import StepperTransfert from "@/components/TransfertInscription/StepperTransfert.vue";
import NavigationStepButtons from "@/components/Inscription/InscriptionItem/NavigationStepButtons.vue";
import IncoherencePopupDialog from "@/components/Inscription/IdentiteCoureur/IncoherencePopupDialog.vue";

export default {
  props: ["transferable_inscription"],
  components: {
    IdentiteCoureur,
    LoginForm,
    ExpandTransition,
    EnteteCoureur,
    StepperTransfert,
    NavigationStepButtons,
    IncoherencePopupDialog,
  },
  data() {
    return {
      current_step: "1",
      incoherence_response: null,
      onload: false,
      dataLoaded: false,
      allowStepScroll: false,
    };
  },

  watch: {
    "transferable_inscription.inscription.id_vague_course": {
      handler() {
        this.sync_vague_selected();
      },
      immediate: true,
    },
    current_step() {
      if (!this.allowStepScroll) {
        return;
      }
      this.scrollToEnteteCoureur();
    },
  },

  computed: {
    ...mapStores(useMainStore, useBookingStore),
    inscription() {
      return this.bookingStore.inscriptions[0];
    },
    account_wording() {
      const is_bicentenaire = this.mainStore.module.is_BICENTENAIRE26_module;
      if (is_bicentenaire) {
        return ["Mon espace personnel", "espace personnel"];
      }
      return ["Mon compte", "compte"];
    },
    ids_selected_parcours() {
      if (this.transferable_inscription.inscription?.id_course) {
        return [this.transferable_inscription.inscription.id_course];
      }
      return [];
    },
  },

  methods: {
    scrollToEnteteCoureur() {
      this.$nextTick(() => {
        const el = this.$refs.enteteCoureurRef;
        if (!el) {
          return;
        }
        const top = el.getBoundingClientRect().top + window.scrollY - 20;
        window.scrollTo({ top, behavior: "smooth" });
      });
    },
    display_incoherence(response) {
      if (this.mainStore.billetterie_mode) return;
      this.incoherence_response = response;
    },
    goToStep(step) {
      const stepNum = parseInt(step);
      const currentNum = parseInt(this.current_step);
      if (stepNum >= currentNum) {
        return;
      }
      switch (step) {
        case "1":
          this.goToIdentityStep();
          break;
        case "2":
          this.goToConfirmationStep();
          break;
        default:
          break;
      }
    },
    goToIdentityStep() {
      this.current_step = "1";
    },
    goToConfirmationStep() {
      this.current_step = "2";
    },
    sync_vague_selected() {
      const inscription = this.transferable_inscription?.inscription;
      const id_vague_course = inscription?.id_vague_course;
      const id_course = inscription?.id_course;
      if (!id_vague_course || !id_course) return;

      const list_courses = this.bookingStore?.inscriptions[0]?.list_courses;
      if (!list_courses?.list) return;

      for (let i = 0; i < list_courses.list.length; i++) {
        const course = list_courses.list[i];
        if (course.id != id_course) continue;

        course.vague_selected = id_vague_course;
        if (course.vagues?.list) {
          for (let j = 0; j < course.vagues.list.length; j++) {
            course.vagues.list[j].selected = course.vagues.list[j].id == id_vague_course;
          }
        }
        break;
      }
    },
    async post() {
      this.onload = true;
      const post_request = await this.bookingStore.post_transfert_inscription(this.transferable_inscription);
      if (post_request) {
        this.$router.push({ name: "CheckoutTransfertSuccess" });
      }
      this.onload = false;
    },
  },

  async mounted() {
    this.mainStore.bookingSystem.init();
    await this.mainStore.champs_formulaire.fetch();
    const booking_inscription = this.bookingStore.inscriptions[0];
    if (booking_inscription.list_courses.list.length == 0) {
      await booking_inscription.list_courses.initialize_from_mainstore(this.mainStore.module.courses.list);
    }
    if (!booking_inscription.list_courses.list.some((course) => course.id == this.transferable_inscription.inscription.id_course && course.selected)) {
      booking_inscription.add_course_from_preselection(this.transferable_inscription.inscription.id_course);
    }
    this.sync_vague_selected();
    if (this.bookingStore.inscriptions[0].list_options.list.length == 0) {
      await this.bookingStore.inscriptions[0].list_options.initialize_from_mainstore(this.mainStore.module.options.list);
      this.bookingStore.inscriptions[0].list_options.add_from_transferable(this.transferable_inscription.inscription);
    }
    if (this.bookingStore.inscriptions[0].list_activites.list.length == 0) {
      await this.bookingStore.inscriptions[0].list_activites.initialize_from_mainstore(this.mainStore.module.activites.list);
      this.bookingStore.inscriptions[0].list_activites.add_from_transferable(this.transferable_inscription.inscription);
    }
    if (this.bookingStore.inscriptions[0].list_articles.list.length == 0) {
      await this.bookingStore.inscriptions[0].list_articles.initialize_from_mainstore(this.mainStore.module.articles_boutique.list);
      this.bookingStore.inscriptions[0].list_articles.add_from_transferable(this.transferable_inscription.inscription);
    }

    this.dataLoaded = true;
    this.allowStepScroll = true;
  },
};
</script>

<style lang="scss" scoped></style>
